import { FormHTMLAttributes } from 'react';

interface FormUploaderZoneProps extends FormHTMLAttributes<HTMLDivElement> {
    hint?: React.ReactNode,
    children?: React.ReactNode,
}

function FormUploaderZone({hint, children, ...props}: FormUploaderZoneProps) {
    return (
        <div className="form__uploader-zone" {...props}>
            <p className="form__uploader-zone-label">
                <label>
                    {children}
                </label>
            </p>
            <p className="form__uploader-zone-hint">
                {hint}
            </p>
        </div>
    );
}

export default FormUploaderZone;